import { render, staticRenderFns } from "./top-page-table.vue?vue&type=template&id=651da8a7&scoped=true"
import script from "./top-page-table.vue?vue&type=script&lang=ts"
export * from "./top-page-table.vue?vue&type=script&lang=ts"
import style0 from "./top-page-table.vue?vue&type=style&index=0&id=651da8a7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "651da8a7",
  null
  
)

export default component.exports